import styled from "styled-components"

const TableContainer = styled.div`
  height: calc(100vh - ${props => props.$showBulkActionsMenu? 330 : 271}px);
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;
  
`

export {
  TableContainer,
}
